import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Backdrop,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	OutlinedInput,
	FormControlLabel,
	Checkbox,
	Radio,
	RadioGroup,
	FormLabel
} from "@mui/material";

import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
	CheckBox,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimeField } from "@mui/x-date-pickers/TimeField";
import Chip from "@mui/material/Chip";
import { groupBy } from "lodash";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { getFormState } from "../../helpers/form";
import Switch from "@mui/material/Switch";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';



export const SwitchA = ({ field, data, onChange, value, index, sxx }) => {
	const { label, required, name, multiple, accept } = field;

	return (
		<FormControlLabel
			required
			control={
				<Switch
					checked={value}
					onChange={(e) => {
						onChange(name, e.target.checked, multiple, index);
					}}
				/>
			}
			label={label}
		/>
	);
};

export const FileUploadA = ({ field, data, onChange, value, index, sxx }) => {
	const { label, required, name, multiple, accept } = field;
	return (
		<Button
			component="label"
			variant="contained"
			sx={{ width: "100%" }}
			startIcon={<CloudUploadIcon />}
		>
			{label}
			{/* <VisuallyHiddenInput type="file" /> */}
			<input
				accept={accept}
				hidden
				type="file"
				onChange={(e) => {
					onChange(e, name, e.target.files, multiple);
				}}
			/>
		</Button>
	);
};

export const NumberFieldA = ({ field, data, onChange, value, index, sxx }) => {
	const { label, required, name, multiline, noMb } = field;
	return (
		<TextField
			required={!!required}
			sx={{ mb: noMb ? 1 : 3, ...(sxx ? sxx : {}) }}
			// autoFocus
			margin="dense"
			label={label}
			type="number"
			value={value}
			name={name}
			InputLabelProps={{
				shrink: true,
			}}
			multiline={!!multiline}
			rows={multiline}
			fullWidth
			size="small"
			variant="outlined"
			onChange={(e) => {
				onChange(name, e.target.value, false, index);
			}}
		/>
	);
};

export const TextFieldA = ({ field, data, onChange, value, sxx }) => {
	const { label, required, name, multiline, noMb } = field;
	return (
		<TextField
			required={!!required}
			sx={{ mb: noMb ? 0 : 3, ...(sxx ? sxx : {}) }}
			// autoFocus
			margin="dense"
			label={label}
			type="text"
			value={value}
			name={name}
			InputLabelProps={{
				shrink: true,
			}}
			multiline={!!multiline}
			rows={multiline}
			fullWidth
			size="small"
			variant="outlined"
			onChange={(e) => {
				onChange(name, e.target.value);
			}}
		/>
	);
};

export const PasswordA = ({ field, data, onChange, value }) => {
	const { label, required, name, noMb } = field;
	return (
		<TextField
			required={!!required}
			sx={{ mb: noMb ? 0 : 3 }}
			// autoFocus
			margin="dense"
			label={label}
			type="password"
			value={value}
			name={name}
			InputLabelProps={{
				shrink: true,
			}}
			fullWidth
			size="small"
			variant="outlined"
			onChange={(e) => {
				onChange(name, e.target.value);
			}}
		/>
	);
};

export const SelectA = ({ field, data, onChange, value, index, sxx, disabled }) => {
	const { label, option, required, name, multiple, noMb } = field;
	const options = data[option.key];
	const optionsMap = groupBy(options, "_id");

	let customizeValue = [];
	if (Array.isArray(value) && value.length > 0) {
		customizeValue = value.map((val) => {
			if (typeof val === "object" && !Array.isArray(val) && val !== null) {
				return val._id;
			} else {
				return val;
			}
		});
	}

	return (
		<>
			{multiple && (
				<FormControl
					variant="outlined"
					sx={{ mb: noMb ? 0 : 1, width: "100%", ...(sxx ? sxx : {}) }}
					required={!!required}
					size="small"
				>
					<InputLabel id="demo-simple-select-standard-label" shrink={true}>
						{label}
					</InputLabel>
					<Select
						disabled={disabled}
						labelId="demo-simple-select-standard-label"
						value={customizeValue}
						multiple={!!multiple}
						onChange={(e) => {
							onChange(name, e.target.value, multiple, index);
						}}

						label={label}
						name={name}
						input={<OutlinedInput label={label} notched={true} />}
						renderValue={(selected) => {
							return (
								<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, maxHeight: 100, overflowY: 'auto', }}>
									{selected
										.filter((v) => optionsMap[v])
										.map((value, i) => (
											<Chip
												key={i}
												onMouseDown={(event) => {
													event.stopPropagation();
												}}
												onDelete={() => {
													let values = [...selected];
													values.splice(i, 1)
													onChange(name, values, multiple, index);
												}}


												label={optionsMap[value][0][option.label]}
											/>
										))}
								</Box>
							);
						}}
					>
						{Array.isArray(options) &&
							options.map((o, i) => {
								return (
									<MenuItem key={i} value={o[option.value]}>
										{o[option.label]}
									</MenuItem>
								);
							})}
					</Select>
				</FormControl>
			)}
			{!multiple && (
				<FormControl
					variant="outlined"
					sx={{ mb: noMb ? 0 : 3, width: "100%", ...(sxx ? sxx : {}) }}
					required={!!required}
					size="small"
				>
					<InputLabel id="demo-simple-select-standard-label" shrink={true}>
						{label}
					</InputLabel>
					<Select
						labelId="demo-simple-select-standard-label"
						value={value}
						multiple={!!multiple}
						onChange={(e) => {
							onChange(name, e.target.value, multiple);
						}}
						renderValue={(value) => {
							return (
								<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
									<Chip
										onMouseDown={(event) => {
											event.stopPropagation();
										}}
										// onDelete={() => {

										// 	// onChange(name, 'Any', multiple);
										// }}
										label={optionsMap[value]?.[0]?.name}
									/>

								</Box>
							);
						}}
						label={label}
						name={name}
						input={<OutlinedInput label={label} notched={true} />}
					>
						{Array.isArray(options) &&
							options.map((o, i) => {
								return (
									<MenuItem key={i} value={o[option.value]}>
										{o[option.label]}
									</MenuItem>
								);
							})}
					</Select>
				</FormControl>
			)}
		</>
		// <TextField
		//     required={!!required}
		//     sx={{ mb: 3 }}
		//     autoFocus
		//     select
		//     multiple={!!multiple}
		//     margin="dense"
		//     label={label}
		//     type="password"
		//     value={value}
		//     name={name}
		//     InputLabelProps={{
		//         shrink: true,
		//     }}
		//     fullWidth
		//     size="small"
		//     variant="outlined"
		//     onChange={(e) => { onChange(name, e.target.value) }}
		// >
		//     {
		//         Array.isArray(options) &&
		//         options.map((o, i) => {
		//             return (
		//                 <MenuItem key={i} value={o[option.value]}>{o[option.label]}</MenuItem>
		//             )
		//         })
		//     }

		// </TextField>
	);
};

export const DatePickerA = ({ field, data, onChange, value, index, sxx }) => {
	const { label, option, required, name, noMb, shouldDisableDate } = field;
	return (
		<DatePicker
			onChange={(v) => {
				onChange(name, v, false, index);
			}}
			format="DD-MM-YYYY"
			slotProps={{ textField: { size: "small", InputLabelProps: { shrink: true } } }}
			name={name}
			value={value}
			// renderInput={(params) => <TextField {...params} InputLabelProps={{ shrink: true }} />}

			shouldDisableDate={shouldDisableDate ? shouldDisableDate : () => false}
			required={!!required}
			sx={{ mb: noMb ? 0 : 3, width: "100%", ...(sxx ? sxx : {}) }}
			label={label}
		/>
	);
};

export const TimeFieldA = ({ field, data, onChange, value, sx }) => {
	const { label, option, required, name } = field;
	return (
		<TimeField
			onChange={(v) => {
				onChange(name, v);
			}}
			slotProps={{ textField: { size: "small" } }}
			label={label}
			name={name}
			value={value}
			sx={{ mb: 3, width: "100%", ...(sx ? sx : {}) }}
		/>
	);
};

export const RowA = ({ field, data, onChange, state }) => {
	const { items } = field;
	return (
		<Box
			sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}
		>
			{Array.isArray(items) &&
				items.map((item, i) => {
					return (
						<Box key={i} sx={{ display: "flex", width: "48%" }}>
							<FieldA
								key={i}
								field={item}
								data={data}
								onChange={onChange}
								state={state}
							/>
						</Box>
					);
				})}
		</Box>
	);
};

export const FieldsA = ({
	field,
	data,
	onChange,
	value,
	index,
	sxx,
	state,
}) => {
	const { items, multiple, label, name } = field;
	// const [valueObj, setValueObj] = useState(value)
	const childState = getFormState(items);
	return (
		<Box sx={{}}>
			<Box sx={{ mb: 2 }}>
				<Typography variant="p">{label}</Typography>
			</Box>

			{!multiple && (
				<Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
					{Array.isArray(items) &&
						items.map((item, i) => {
							return (
								<Box key={i} sx={{ display: "flex", width: "100%" }}>
									<FieldA
										field={item}
										data={data}
										onChange={(name, val, multiple) => {
											let newValue = { ...value };
											newValue[name] = val;
											onChange(field.name, newValue, multiple);
										}}
										state={value}
										sxx={item.sxx}
									/>
								</Box>
							);
						})}
				</Box>
			)}
			{multiple &&
				value.map((v, i) => {
					return (
						<Box
							key={i}
							sx={{ display: "flex", flexDirection: "column", width: "100%" }}
						>
							{Array.isArray(items) &&
								items.map((item, j) => {
									return (
										<Box
											key={i + "" + j}
											sx={{ display: "flex", width: "100%" }}
										>
											<FieldA
												field={item}
												data={data}
												onChange={(name, val, multiple) => {
													let newValue = [...value];
													newValue[i][name] = val;
													onChange(field.name, newValue, multiple);
												}}
												state={v}
												sxx={item.sxx}
											/>
										</Box>
									);
								})}
						</Box>
					);
				})}
			{multiple && (
				<Button
					onClick={(e) => {
						let newValue = [...value];
						newValue.push(childState);
						onChange(name, newValue, multiple);
					}}
				>
					{" "}
					+ more
				</Button>
			)}
		</Box>
	);
};

export const FieldA = ({ field, data, onChange, state, sxx }) => {
	const { type, name, items } = field;
	return (
		<>
			{type == "text" && (
				<TextFieldA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{type == "number" && (
				<NumberFieldA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{type == "select" && (
				<SelectA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{type == "date" && (
				<DatePickerA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{type == "password" && (
				<PasswordA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{type == "group" && (
				<RowA
					field={field}
					data={data}
					onChange={onChange}
					state={state}
					sxx={sxx}
				/>
			)}
			{type == "time" && (
				<TimeFieldA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
				/>
			)}
			{type == "fields" && (
				<FieldsA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{type == "switch" && (
				<SwitchA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{type == "textArea" && (
				<TextAreaA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{type == "checkbox" && (
				<CheckBoxA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{type == "radio" && (
				<RadioA
					field={field}
					data={data}
					onChange={onChange}
					value={state[name]}
					sxx={sxx}
					state={state}
				/>
			)}
			{
				type == 'DateTime' && (
					<DateTime
						field={field}
						onChange={onChange}
						value={state[name]}

					/>
				)
			}
		</>
	);
};

export const FormA = ({ fields, data, onChange, state }) => {
	return (
		<Box>
			{Array.isArray(fields) &&
				fields.map((f, i) => {
					return (
						<Box key={i}>
							<FieldA field={f} data={data} onChange={onChange} state={state} />
						</Box>
					);
				})}
		</Box>
	);
};

export const TextAreaA = ({ field, data, onChange, value, sxx }) => {
	const { label, required, name, multiline, noMb } = field;
	return (
		<TextField
			required={!!required}
			sx={{ mb: noMb ? 0 : 3, ...(sxx ? sxx : {}) }}
			// autoFocus
			margin="dense"
			label={label}
			type="text"
			value={value}
			name={name}
			InputLabelProps={{
				shrink: true,
			}}
			multiline
			rows={3}
			fullWidth
			size="small"
			variant="outlined"
			onChange={(e) => {
				onChange(name, e.target.value);
			}}
		/>
	);
};

export const CheckBoxA = ({ field, data, onChange, value, sxx }) => {
	const { label, required, name, multiline, noMb } = field;
	return (
		<FormControlLabel
			required
			control={
				<Checkbox
					onChange={(e) => {
						onChange(name, e.target.value);
					}}
				/>
			}
			label={label}
		/>
	);
};

export const RadioA = ({ field, data, onChange, value, sxx }) => {
	const { label, required, name, multiline, noMb, option } = field;
	const options = data[option.key];

	return (
		<>
			<FormLabel>
				{label}
			</FormLabel>
			<RadioGroup
				aria-labelledby="demo-radio-buttons-group-label"
				name={name}
				row
				onChange={(e) => {
					onChange(name, e.target.value);
				}}
			>
				{Array.isArray(options) &&
					options.map((o, i) => {
						return (
							<FormControlLabel value={o[option.value]} control={<Radio />} label={o[option.label]} key={i} sx={{ mb: noMb ? 0 : 3, ...(sxx ? sxx : {}) }} />
						);
					})}

			</RadioGroup>
		</>

	);
};

export const DateTime = ({ field, data, onChange, value, sxx }) => {
	const { label, required, name, multiline, noMb, } = field;
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DateTimePicker
				label={label}
				value={value}
				onChange={onChange}
				format="DD-MM-YYYY HH:MM:SS"
			/>
		</LocalizationProvider>
	)
}